(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/coupon.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/coupon.js'); 
'use strict';

svs.tipset.isCouponLoaded = false;

svs.tipset.views.Coupon = Backbone.Marionette.View.extend({
  regions: {
    drawSelector: '#drawChooser',
    matchlist: '#matchlist',
    uSystem: '#uSignRow',
    bomben: '#additionalBombenGame',
    reduceFreeContainer: '#reduce-free-container'
  },

  modelEvents: {
    showUsystemBtn: 'showUsystemBtn'
  },

  events: {
    'click .js-coupon-clear-all': 'clearAll',
    'click .js-help-dialog-mark': 'helpDialogMark'
  },

  template: function(data) {
    return svs.tipset.templates.coupon(data);
  },

  initialize: function() {
    this.listenTo(svs.tipset.models.play, 'change', function() {
      this.handleReduceRegion();
    });

    if (
      svs.core.detect.feature('ft-betslip') &&
      !svs.core.detect.formfactor.mobile()
    ) {
      this.addRegion('betslipRegion', '#betslip-wrapper');
      this.addRegion('betslipOverview', '#tipset-slider-folder');
    }
  },

  onAttach: function() {
    if (!svs.tipset.data.isRetailerAdmin) {
      this.addDrawSelector();
    }
    this.addNavButtons();
    this.addMatchList();

    var system = svs.tipset.models.systems.getCurrentSystem();

    svs.tipset.views.actionbar = new svs.tipset.views.TipsenActionbar({
      model: new svs.tipset.models.TipsetActionbar()
    });

    if (
      svs.tipset.models.gameDefinitions.get('productName') ===
      svs.tipset.constants.PRODUCTNAME.POWERPLAY
    ) {
      var hasMarketPlaceAccount =
          svs.components.marketplace &&
          svs.components.marketplace.accountSelector,
        isMarketPlaceAccount =
          hasMarketPlaceAccount &&
          svs.components.marketplace.accountSelector.helpers.getCurrentAccount();

      if (hasMarketPlaceAccount) {
        var self = this;
        self.updateBombenButton = self.updateBombenButton.bind(self);
        svs.components.marketplace.accountSelector.helpers.observer.subscribe(
          self.updateBombenButton
        );
      }

      if (!isMarketPlaceAccount) {
        this.addBomben();
      }
    }
    svs.tipset.views.actionbar.removeActionBar();
    svs.tipset.views.actionbar.showActionbarSystem();

    if (system && system.type === 'U') {
      this.showUsystemBtn();
    }
    if (
      svs.core.detect.feature('ft-betslip') &&
      !svs.core.detect.formfactor.mobile()
    ) {
      this.getRegion('betslipOverview').show(
        svs.tipset.views.betslipOverview = new svs.tipset.views.BetslipOverview(
          {
            model: svs.tipset.models.betslipExpanded
          }
        )
      );
    }
  },

  addDrawSelector: function() {
    var drawselectorOptions = {
      callback: svs.tipset.selectDraw,
      draws: svs.tipset.collections.draws.getAllDraws(),
      currentDraw: svs.tipset.collections.draws
        .getCurrentDraw()
        .get('drawNumber'),
      branding: svs.tipset.models.gameDefinitions.get('htmlClass'),
      swiperUpdateFunction: this.updateSwiper
    };

    this.getRegion('drawSelector').show(
      new svs.sport.drawselector.views.Drawselector(drawselectorOptions)
    );

    if (!svs.tipset.isCouponLoaded) {
      svs.components.animation.add(
        this.$el.find('.js-extra-text'),
        'animate animate-elastic-from-right animate-time-3ms animate-delay-8ms animate-fill-mode-both animate-timing-ease-out'
      );
      svs.tipset.isCouponLoaded = true;
    }
  },

  addNavButtons: function() {
    svs.tipset.models.header.resetCenter();
    if (svs.utils.initContextMenu) {
      svs.utils.initContextMenu();
    }
  },

  stickyUsign: function() {
    var uSignRow = document.getElementById('uSignRow'),
      pageOffset = svs.components.header.getTopContentWrapperHeight();

    if (uSignRow && window.pageYOffset > pageOffset + 155) {
      uSignRow.classList.add('sticky');
    } else if (uSignRow) {
      uSignRow.classList.remove('sticky');
    }
  },

  addMatchList: function() {
    svs.tipset.views.matchlist = new svs.tipset.views.Matchlist({
      collection: svs.tipset.collections.matchlist
    });
    this.getRegion('matchlist').show(svs.tipset.views.matchlist);
  },

  addBomben: function() {
    this.getRegion('bomben').show(
      new svs.tipset.views.BombenButton({
        model: new svs.tipset.models.BombenButton({
          hasBomben: svs.tipset.views.matchlist.collection.hasBomben()
        })
      })
    );
  },

  updateSwiper: function() {
    if (!svs.core.detect.formfactor.mobile()) {
      svs.tipset.multiSwiper.updateSize();
    }
  },

  clearAll: function() {
    var self = this;

    svs.tipset.views.contextualmenu.onRensaTecken(function() {
      if (!svs.core.detect.formfactor.mobile()) {
        svs.tipset.multiSwiper.scrollTo(0, 0, 0, false);
      } else {
        self.$el.parents('.js-swiper-container').scrollTop(0);
      }
    });
  },

  showUsystemBtn: function() {
    var actionBar,
      currentSystem = svs.tipset.models.systems.getCurrentSystem();
    if (
      currentSystem &&
      currentSystem.type === 'U' &&
      !this.getRegion('uSystem').hasView()
    ) {
      if (svs.core.detect.formfactor.mobile()) {
        $(window).scroll(this.stickyUsign);
      }

      this.getRegion('uSystem').show(
        new svs.tipset.views.USystemButton({
          model: new svs.tipset.models.UsystemButton()
        })
      );

      setTimeout(function() {
        actionBar = document.getElementsByClassName('actionbar')[0];
        if (actionBar) {
          actionBar.classList.add('actionbar-clear-bottom-border');
        }
      });
    } else {
      if (svs.core.detect.formfactor.mobile()) {
        $(window).off('scroll', this.stickyUsign, this);
      }

      this.getRegion('uSystem').empty();

      setTimeout(function() {
        actionBar = document.getElementsByClassName('actionbar')[0];
        if (actionBar) {
          actionBar.classList.remove('actionbar-clear-bottom-border');
        }
      });
    }
  },

  onRender: function() {
    this.handleReduceRegion();
  },

  handleReduceRegion: function() {
    if (svs.tipset.models.play.get('isReduceMode')) {
      this.getRegion('reduceFreeContainer').show(
        new svs.tipset.views.ReduceFreeContainer()
      );
    } else {
      this.getRegion('reduceFreeContainer').empty();
    }
  },

  helpDialogMark: function(e) {
    if (svs.tipset.data.config.helpTexts) {
      var _dialog = new svs.components.dialog.Contextual({
        branding: svs.components.dialog.branding.SPORT,
        attachTo: $(e.currentTarget),
        zIndex: svs.core.detect.formfactor.mobile() ? 140 : 160,
        title: svs.tipset.data.config.helpTexts.startpage_mark.title,
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: svs.tipset.data.config.helpTexts.startpage_mark.body
          }
        ]
      });
      svs.components.dialog.api.add(_dialog);
    }
  },

  updateBombenButton: function(ref) {
    if (ref.currentAccount) {
      if (this.getRegion('bomben').hasView()) {
        this.getRegion('bomben').empty();
      }
    } else {
      if (!this.getRegion('bomben').hasView()) {
        this.addBomben();
      }
    }
  }
});

 })(window);